import type { ICard } from "../../cardsSlice";

export const major12Card: ICard = {
    id: "major_12",
    arcana: "major",
    number: 12,
    suit: "major",
    court: "major",
    name: "Повешенный",
    nameEn: "The Hanged Man",
    keywords: ["Жертва", "Переосмысление", "Освобождение"],
    symbolism: ["Человек, висящий вниз головой за ногу", "Нимб, спокойное выражение лица", "Согнутая нога"],
    symbolismInterpretation:
      "Добровольная остановка и изменение перспективы ради нового понимания",
    archetype: "Архетип жертвы, отказа от эго, путь к внутреннему прозрению",
    psychology: "Принятие, терпение, отказ от контроля ради постижения",
    upright: {
      personality: "Смирение, терпимость, внутренняя тишина",
      relationships: "Временное отстранение, пересмотр ценностей",
      work: "Необходимость переосмыслить цели или подход",
      spirituality: "Выход за рамки эго, переход к глубинному восприятию",
      examples: ["Добровольное ожидание", "Переоценка", "Новый взгляд"]
    },
    reversed: {
      meaning: "Застой, внутреннее сопротивление, отказ от роста",
      nuances: "Ощущение бессмысленности, страх изменений"
    },
    associations: ["Пауза", "Переворот", "Ожидание", "Отказ"],
    combinations: ["С Отшельником — внутренняя работа и уединение", "Со Смертью — завершение цикла и освобождение"],
    readingTips: ["Не путать остановку с поражением", "Понять, что требуется новый взгляд"],
    selfQuestions: ["От чего мне пора отказаться?", "Какой опыт переворачивает моё восприятие?"]
  };


